import { BarChart3 } from 'lucide-react';
import { useDappDataOptional } from '../../contexts/DappDataContext';
import { usePageTitle } from '../../hooks/usePageTitle';
import { useOptionalDappContext } from '../DappLayout';
import { PortalCard, PortalPage, PortalPageHeader } from '../portal';

export const DashboardAnalytics = () => {
  const dappId = useOptionalDappContext()?.dappId;
  const { dappData } = useDappDataOptional();
  const dappName = dappData?.dappName || null;

  usePageTitle(
    dappId && dappName
      ? `${dappName} - Analytics | Publishing Portal`
      : 'Analytics | Publishing Portal',
  );

  return (
    <PortalPage>
      <PortalPageHeader icon={<BarChart3 />} title="Analytics" />
      <PortalCard className="p-8 text-center">
        <div className="text-xl font-semibold text-white">
          Analytics Dashboard
        </div>
        <p className="mt-2 text-sm text-seeker-400">
          View analytics and metrics for your dApps.
        </p>
      </PortalCard>
    </PortalPage>
  );
};
